



// /api/file/upload

//oss文件上传的链接地址
export const ossUploadUrl='/api/file/upload';